import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import BusinessTabSettings from "../components/BusinessTabSettings";
import { useGetSettingsMutation } from "redux/settings/settingsSlice";
import { useSelector } from "react-redux";
import AppContainer from "components/ui/AppContainer";
const BusinessSettings = () => {
  const { t } = useTranslation();
  const [getSettings] = useGetSettingsMutation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  useEffect(() => {
    const userDetail = UTILS.getCurrentUser();
    const obj = {
      brandId: userDetail.brandId,
      language: "EN",
    };
    getSettings(obj);
  }, []);

  return (
    <AppContainer
      title={t("Business settings")}
      subTitle={t("View and manage your business details.")}
      loading={isLoading}
    >
      <div className="pb-8">
        <BusinessTabSettings />
      </div>
    </AppContainer>
  );
};

export default BusinessSettings;
